import React, { useEffect, useRef } from 'react';
import { handleImageError } from '../utils/imageOptimization';

// Customer photos for carousel
const CUSTOMER_PHOTOS = [
  { src: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/zckyiqoy_704ab948-5412-4b1a-9cc9-a0dcf8b790ab.webp", alt: "Brown bag cream sweater" },
  { src: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/83t46bzg_c981bd61-ade7-4173-962e-9051754e74ba.webp", alt: "Red bag overhead tattooed hand" },
  { src: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/dj646sos_aae15b82-a49a-40a2-9ff6-c0d0e0d3449a.webp", alt: "Red bag trench coat" },
  { src: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/024qqzr1_5f769d77-9a75-4761-87b1-289c0e63f12d.jpg", alt: "Cuban chain golden skin" },
  { src: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/wxytlkvi_71142150-e4ca-4419-b48d-1b31ff48c76e.webp", alt: "Cuban chain white turtleneck" },
  { src: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/m3t6swxw_1631589027129987072.webp", alt: "Cuban chain white shirt" },
  { src: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/jky5geaz_b87a0697-237d-473b-92ea-96658d12fe27.webp", alt: "Gold ring cream fabric" },
  { src: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/umlnrloa_Screenshot%202026-03-27%20at%208.19.22%E2%80%AFPM.png", alt: "Brown bag white bedding" },
  { src: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/5df7q68e_Screenshot%202026-03-27%20at%208.19.40%E2%80%AFPM.png", alt: "Brown bag leather chair" },
];

// Customer reviews
const REVIEWS = [
  {
    text: "arrived fast, looks way more expensive than it is. fits everything — phone, wallet, the works. zero bad smell. genuinely obsessed.",
    name: "J.",
    product: "The Bag"
  },
  {
    text: "exactly like the photos. i've gotten so many compliments already.",
    name: "H.",
    product: "The Bag"
  },
  {
    text: "the brown. every single day. don't think about it, just get it.",
    name: "U.",
    product: "The Bag"
  },
];

const SocialProof = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let animationId;
    let scrollPosition = 0;
    const scrollSpeed = 0.5;

    const animate = () => {
      scrollPosition += scrollSpeed;
      if (scrollPosition >= scrollContainer.scrollWidth / 2) {
        scrollPosition = 0;
      }
      scrollContainer.scrollLeft = scrollPosition;
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    const handleMouseEnter = () => cancelAnimationFrame(animationId);
    const handleMouseLeave = () => { animationId = requestAnimationFrame(animate); };

    scrollContainer.addEventListener('mouseenter', handleMouseEnter);
    scrollContainer.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      cancelAnimationFrame(animationId);
      scrollContainer.removeEventListener('mouseenter', handleMouseEnter);
      scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <div data-testid="social-proof-section">
      {/* Trust Bar - CHANGE 2: Updated text */}
      <div className="bg-plumo-bone py-4">
        <p 
          style={{
            fontFamily: "'Space Mono', monospace",
            fontSize: '12px',
            fontWeight: 400,
            letterSpacing: '0.15em',
            color: '#555',
            textAlign: 'center',
            textTransform: 'uppercase',
          }}
        >
          LOS ANGELES · 2026 · THE THINGS WORTH CARRYING
        </p>
      </div>

      {/* Customer Photo Carousel */}
      <section className="bg-white py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-10">
          <h2 
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 600,
              fontSize: 'clamp(24px, 3vw, 32px)',
              color: '#0D0D0B',
              letterSpacing: '-0.01em',
            }}
          >
            As worn.
          </h2>
        </div>

        {/* Photo Strip */}
        <div 
          ref={scrollRef}
          className="flex gap-3 overflow-x-auto scrollbar-hide"
          style={{ scrollBehavior: 'auto' }}
        >
          {[...CUSTOMER_PHOTOS, ...CUSTOMER_PHOTOS].map((photo, index) => (
            <div 
              key={index} 
              className="flex-shrink-0 w-48 h-48 md:w-64 md:h-64"
            >
              <img
                src={photo.src}
                alt={photo.alt}
                width="256"
                height="256"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
                onError={handleImageError}
              />
            </div>
          ))}
        </div>

        {/* CHANGE 3: Replaced reviews with centered text */}
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 mt-16">
          <div 
            style={{
              textAlign: 'center',
              padding: '40px 0',
            }}
          >
            <p
              style={{
                fontFamily: "'Space Mono', monospace",
                fontSize: '15px',
                color: '#0D0D0B',
                marginBottom: '14px',
              }}
            >
              by the ones who found us first.
            </p>
            <p
              style={{
                fontFamily: "'Space Mono', monospace",
                fontSize: '15px',
                color: '#0D0D0B',
              }}
            >
              tag @plumo.world to be seen.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SocialProof;
